var RepaymentReport = function () { return import('~/pages/report-manage/repayment-report.vue'); };
var CollectDaysReport = function () { return import('~/pages/report-manage/collect-days-report.vue'); };
var PerformanceReport = function () { return import('~/pages/report-manage/performance-report.vue'); };
var WarehousingVehicleReport = function () { return import('~/pages/report-manage/warehousing-vehicle-report.vue'); };
var CommissionReport = function () { return import('~/pages/report-manage/commission-report.vue'); };
export default [
    {
        path: '/report-manage/repayment-report',
        title: '回款统计',
        name: 'repayment-report',
        component: RepaymentReport
    },
    {
        path: '/report-manage/performance-report',
        title: '绩效报表',
        name: 'performance-report',
        component: PerformanceReport
    },
    {
        path: '/report-manage/warehousing-vehicle-report',
        title: '入库车辆报表',
        name: 'warehousing-vehicle-report',
        component: WarehousingVehicleReport
    },
    {
        path: '/report-manage/commission-report',
        title: '佣金报表',
        name: 'commission-report',
        component: CommissionReport
    },
];
